// Texty produktovej karty — slovenské dvojča productCard.js.
import { plural } from '../plural.js';

export default {
  bestseller: 'Bestseller',
  inStock: 'Skladom',
  /** 1 recenzia / 2–4 recenzie / 5+ recenzií */
  reviewsWord: (n) => plural(n, ['recenzia', 'recenzie', 'recenzií']),
  ctaSuffix: (price) => ' za ' + price,
};
